<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="item_title">站点</span>
        <el-autocomplete
          v-model="parameterNames.channel_code_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          style="width: 250px"
          @focus="current = '站点'"
          @select="handleSelect"
          @clear="channel_code = null"
        />
      </div>
      <div class="item">
        <span class="item_title">平台</span>
        <el-autocomplete
          v-model="parameterNames.platform_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '平台'"
          @select="handleSelect"
          @clear="platform_id = null"
        />
      </div>
      <div class="item">
        <span class="item_title">投放组</span>
        <el-autocomplete
          v-model="parameterNames.release_group_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投放组'"
          @select="handleSelect"
          @clear="release_group_id = null"
        />
      </div>
      <div class="item">
        <span class="item_title">投手</span>
        <el-autocomplete
          v-model="parameterNames.pitcher_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投手'"
          @select="handleSelect"
          @clear="pitcher_id = null"
        />
      </div>
      <div class="item">
        <span class="item_title">书籍归属</span>
        <el-autocomplete
          v-model="parameterNames.book_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '书籍归属'"
          @clear="book_id = null"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">书名</span>
        <el-autocomplete
          v-model="parameterNames.alias_book_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '书名'"
          @clear="alias_book_id = null"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">投放位置</span>
        <el-autocomplete
          v-model="parameterNames.position_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投放位置'"
          @clear="position_id = null"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">日期</span>
        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <el-button
        style="height: 37px"
        type="primary"
        icon="el-icon-search"
        @click="search"
      >搜索</el-button>
      <el-button
        style="height: 37px"
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
      <el-button
        style="height: 37px"
        type="primary"
        icon="el-icon-download"
        @click="reportExport"
      >导出</el-button>
      <el-button
        style="height: 37px"
        type="primary"
        @click="myUpdata"
      >更新</el-button>
    </div>
    <div>
      <el-table
        ref="table"
        :key="maxLength"
        v-loading="loading"
        :data="tableData.list"
        :span-method="objectSpanMethod"
        :header-cell-style="handerMethod"
        max-height="650"
        border
        style="width: 100%"
      >
        <el-table-column prop="channel_date" label="时间" width="150" />

        <el-table-column prop="total_recharge" label="累积充值" />

        <el-table-column prop="consume" label="成本" />
        <el-table-column
          label="累积回本率"
          :show-overflow-tooltip="true"
          align="center"
          prop="gradeScopBegin"
        >
          <template scope="scope">
            <span style="color: red">{{ scope.row.t_tcbi }}%</span>
          </template>
        </el-table-column>

        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="gradeScopEnd"
        >
          <template scope="scope">
            <span
              :style="{
                color: scope.row.my_app_name === '总回本率' ? 'red' : null
              }"
            >{{ scope.row.my_app_name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="index in maxLength"
          :key="index"
          :label="'第' + index"
        >
          <template scope="scope">
            <span
              :style="{
                color: scope.row.my_app_name === '总回本率' ? 'red' : null
              }"
            >
              {{ mygetValue(scope.row, index) }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import {
  tFigureListNovelSite,
  getTheListOfOfficialAccountNovelSite,
  getReleaseGroupListNovel,
  getListOfPitchersInTheLaunchGroupNovel,
  getTitleListNovel,
  getBookOwnershipListNovel,
  dropLocationListNovel,
  exportTFigureListNovelSite,
  toUpdateNovelSite,
  getPlatform
} from '@/api/newLaunchGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
    /* Details */
  },
  data() {
    return {
      tableData: {},
      loading: false,

      // 存储选中的项
      parameter: {
        release_group_id: null,
        pitcher_id: null,
        alias_book_id: null,
        book_id: null,
        position_id: null,
        channel_code: null
      },

      // 存储选中的名字
      parameterNames: {
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        alias_book_id_name: null, // 书名
        book_id_name: null, // 书籍归属
        position_id_name: null, // 投放位置
        channel_code_name: null
      },

      // 分页信息
      paging: {
        page: 1,
        pageSize: 10
      },
      current: null, // 表示当前选中的搜索类型
      date: [this.getNowFormatDate(true), this.getNowFormatDate()],
      activeItem: null,
      activeText: null,
      drawerItem: {},
      maxLength: 0,
      ids: {},
      randomId: Math.random(),
      hasSearched: []
    }
  },
  async created() {
    window.aa = this
    // await this.initOfficialAccount()
    // this.getDataList(this.constructRequestDataStructure())
  },

  mounted() {
    window.addEventListener('resize', this.displayWindowSize) // 监听窗口变化
  },

  updated() {
    this.ids = {}
    this.$refs['table'] && this.$refs['table'].doLayout() // 数据更新表格重渲染
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.displayWindowSize) // 组件卸载时删除添加的事件
  },
  methods: {
    // 获取数据列表
    async getDataList(obj = {}) {
      this.loading = true
      this.ids = {}
      const data = await tFigureListNovelSite(obj) // 获取数据
      this.maxLength = this.getMaxLength(data.data.list) // 获取最大长度
      this.tableData = data.data
      this.tableData.list = this.tableData.list.map((item) => {
        return { ...item, id: Math.random() }
      }) // 向每一项注入一个随机数id
      this.tableData.list = this.constructRenderingDataStructure(
        this.tableData.list
      ) // 构造出渲染所需要的数据结构
      this.loading = false
    },

    // 获取value
    mygetValue(row, index) {
      if (row.my_app_name === '回本率') {
        return row.my_data[index - 1] && row.my_data[index - 1] + '%'
      } else if (row.my_app_name === '总回本率') {
        return row.my_data[index - 1] && row.my_data[index - 1].tcbi + '%'
      }
      return row.my_data[index - 1] && row.my_data[index - 1]
    },

    // 初始化数据
    async initOfficialAccount() {
      this.current = '公众号'
      const data = await getTheListOfOfficialAccountNovelSite() // 获取公众号
      /* const news = */ data.data.list.map((item) => {
        return {
          value: item.account_name,
          address: item.app_id
        }
      })
      // 默认选中第一项
      // this.handleSelect(news[0])

      // this.parameterNames.app_id_name = news[0].value
    },

    // 分页
    fetchPageSize(s) {
      this.paging.pageSize = s
      this.getDataList(this.constructRequestDataStructure())
    },

    // 分页
    fetchCurrentPage(s) {
      this.paging.page = s
      this.getDataList(this.constructRequestDataStructure())
    },

    // 搜索
    async querySearchAsync(queryString, cb) {
      let currentFunc = null // 将存储请求的函数
      const obj = {
        投放组: 'release_group_name',
        投手: 'user_name',
        书籍归属: 'book_name',
        书名: 'novel_name',
        投放位置: 'position_name',
        站点: 'channel_code_name',
        平台: 'platform_name'
      }

      // 循环判断当前选中哪一项，并赋值对应的请求函数
      switch (this.current) {
        case '投放组':
          currentFunc = getReleaseGroupListNovel
          break
        case '投手':
          currentFunc = getListOfPitchersInTheLaunchGroupNovel
          break
        case '书名':
          currentFunc = getTitleListNovel
          break
        case '书籍归属':
          currentFunc = getBookOwnershipListNovel
          break
        case '投放位置':
          currentFunc = dropLocationListNovel
          break
        case '站点':
          currentFunc = getTheListOfOfficialAccountNovelSite
          break
        case '平台':
          currentFunc = getPlatform
          break
      }

      // 没有请求函数则直接结束
      if (!currentFunc) {
        return
      }

      // 条件
      const bool1 = this.current === '投手' && !this.parameter.release_group_id
      const bool3 = this.current === '书名' && !this.parameter.book_id

      // 投手、运营者、书名 请求时必须满足条件才给予请求
      if (bool1 || bool3) {
        const obj1 = {
          投手: '请先选投放组，才能选投手',
          书名: '请先选择书籍归属，才能选书名'
        }
        this.$message({
          message: obj1[this.current],
          type: 'warning'
        })
        cb([])
        return
      }

      let valueID = null

      // 判断当前要请求的是不是这两项, 如果是那么将获取 投放组或运营组选择的项的id
      if (this.current === '投手') {
        valueID =
          this.current === '投手'
            ? this.parameter.release_group_id.address
            : null
      }
      let result = null
      console.log('item:', queryString)
      if (this.current === '站点' && queryString !== null) {
        result = queryString.replace(/\([^()]+\)/g, '')
      }
      if (this.current === '站点' && this.hasSearched.length !== 0) {
        var restaurants = this.hasSearched
        var results = result
          ? restaurants.filter(this.createFilter(result))
          : restaurants
        // 调用 callback 返回建议列表的数据
        console.log('results:', results)
        // cb(results)
        cb(
          results.map((item) => {
            return item
          })
        )
        return
      }

      // 请求数据
      const data = await currentFunc({
        name: this.current !== '站点' ? queryString : null, // 输入的内容
        channel_name: this.current === '站点' ? result : null,
        group_id: valueID, // 该属性只有投手和运营者有值
        book_belong_id: this.parameter.book_id
          ? this.parameter.book_id.address
          : null, // 该属性属性列表有值
        type: this.current === '投放组' ? 2 : null // 该项只有投放组有值
      })

      // 重新构造列表项所需要的数据
      const news = data.data.list.map((item) => {
        if (this.current === '站点') {
          this.hasSearched.push({
            value:
              this.current === '站点'
                ? `${item.channel_name}(${item.platform_str})`
                : this.current === '平台'
                  ? item.name
                  : item[obj[this.current]],
            address: this.current === '站点' ? item.channel_code : item.id
          })
        }
        return {
          value:
            this.current === '站点'
              ? `${item.channel_name}(${item.platform_str})`
              : this.current === '平台'
                ? item.name
                : item[obj[this.current]],
          address: this.current === '站点' ? item.channel_code : item.id
        }
      })

      cb(news)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.value
          .toLowerCase()
          .includes(queryString.toLowerCase())
      }
    },

    // 选中哪一项
    handleSelect(item) {
      switch (this.current) {
        case '投放组':
          this.parameter.release_group_id = item
          break
        case '投手':
          this.parameter.pitcher_id = item
          break
        case '书名':
          this.parameter.alias_book_id = item
          break
        case '书籍归属':
          this.parameter.book_id = item
          break
        case '投放位置':
          this.parameter.position_id = item
          break
        case '站点':
          this.parameter.channel_code = item
          break
        case '平台':
          this.parameter.platform_id = item
          break
      }
    },

    // 构造请求时所需要的数据结构
    constructRequestDataStructure() {
      // 数据的对应属性名
      const obj = {
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name',
        alias_book_id: 'alias_book_id_name',
        book_id: 'book_id_name',
        position_id: 'position_id_name',
        channel_code: 'channel_code_name',
        platform_id: 'platform_name'
      }
      const keys = Object.keys(this.parameter) // 将其变成数组

      const obj1 = {}

      // 循环数组构造数据结构
      keys.map((key, index) => {
        console.log('key:', key)
        // 判断该选有没有选中的并且必须要值必须相等不能被修改
        if (
          this.parameter[key] &&
          this.parameter[key].value === this.parameterNames[obj[key]]
        ) {
          obj1[key] = this.parameter[key].address
        } else {
          obj1[key] = null
        }
      })
      obj1.begin_time = this.date && this.date.length ? this.date[0] : null
      obj1.end_time = this.date && this.date.length ? this.date[1] : null

      return {
        ...obj1,
        ...this.paging
      }
    },

    // 搜索
    search() {
      this.paging.page = 1
      const data = this.constructRequestDataStructure()
      if (!data.begin_time) {
        this.$message({
          message: '日期是必须的',
          type: 'warning'
        })
        return
      }
      this.getDataList(data)
    },

    // 重置
    reset() {
      this.paging = {
        page: 1,
        pageSize: 10
      }
      this.parameter = {
        release_group_id: null,
        pitcher_id: null,
        alias_book_id: null,
        book_id: null,
        position_id: null,
        channel_code: null,
        platform_id: null
      }
      this.parameterNames = {
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        alias_book_id_name: null, // 书名
        book_id_name: null, // 书籍归属
        position_id_name: null, // 投放位置
        channel_code_name: null,
        platform_name: null
      }
      this.current = null
      this.ids = {}
      this.getDataList(this.constructRequestDataStructure())
    },

    // 导出报表
    async reportExport() {
      const obj = this.constructRequestDataStructure() // 构造出请求所需要的数据结构

      // 判断公众号和日期是否都有没有选
      if (!obj.channel_code || !obj.begin_time || !obj.end_time) {
        this.$message({
          message: '站点和日期必填',
          type: 'warning'
        })
        return
      }

      // 导出报表
      await exportTFigureListNovelSite(obj)
      this.$message({
        message: '已在后台中导出',
        type: 'success'
      })

      /* this.reset() // 重置数据*/
    },

    // 构造渲染时所需要的数据结构
    constructRenderingDataStructure(list) {
      const data = []
      for (let i = 0; i < list.length; i++) {
        data.push({
          ...list[i],
          my_app_name: list[i].data[0].channel_code,
          my_data: list[i].data[0].data
        })
        if (list[i].data.length > 1) {
          for (let l = 0; l < list[i].data.length - 1; l++) {
            data.push({
              ...list[i],
              my_app_name: list[i].data[l + 1].channel_code,
              my_data: list[i].data[l + 1].data
            })
          }
        }
        data.push({ ...list[i], my_app_name: '回本率', my_data: list[i].zcb })
        data.push({
          ...list[i],
          my_app_name: '总回本率',
          my_data: list[i].tcbi
        })
      }

      return data
    },

    /**
     * 合并行或列的计算方法
     * columnIndex 当前列  竖
     * rowIndex    当前行  横
     */
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 判断列
      if (
        columnIndex === 0 ||
        columnIndex === 1 ||
        columnIndex === 2 ||
        columnIndex === 3
      ) {
        if (!this.ids[row.id] || this.ids[row.id] < 4) {
          this.ids[row.id] ? (this.ids[row.id] += 1) : (this.ids[row.id] = 1)
          return {
            rowspan: row.data.length + 2, // rowspan为合并的行数
            colspan: 1 // colspan为合并的列数
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },

    // 处理表格
    handerMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        // 行索引为0代表表头那一行
        if (columnIndex === 3) {
          // 列索引，找到你自己要合并的那一列，这个是动态的，根据实际需求来
          this.$nextTick(() => {
            if (document.getElementsByClassName(column.id).length !== 0) {
              document
                .getElementsByClassName(column.id)[0]
                .setAttribute('colSpan', 2)
            }
          })
        } else if (columnIndex === 4) {
          this.$nextTick(() => {
            if (document.getElementsByClassName(column.id).length !== 0) {
              document.getElementsByClassName(column.id)[0].style.display =
                'none'
            }
          })
        }
      }
    },

    // 获取最大长度
    getMaxLength(list = []) {
      let num = null
      for (let i = 0; i < list.length; i++) {
        num || (num = list[i].tcbi.length)
        num < list[i].tcbi.length && (num = list[i].tcbi.length)
      }
      return num || 0
    },

    // 生成当前日期
    getNowFormatDate(whether) {
      var date = whether
        ? new Date(Date.now() - 15 * (24 * 60 * 60 * 1000))
        : new Date()
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    },

    // 窗口大小改变触发的事件
    displayWindowSize() {
      this.ids = {}
      this.$refs['table'].doLayout && this.$refs['table'].doLayout()
    },

    async myUpdata() {
      await toUpdateNovelSite()
      this.$message({
        message: '在后台中更新，请稍等（实时更新）',
        type: 'success'
      })
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.content {
  .item {
    display: flex;
    align-items: center;
    .item_title {
      display: inline-block;
      width: 100px;
    }
    .item_input {
      width: 200px;
    }
  }
}

.selectionArea {
  display: flex;
  flex-wrap: wrap;
  .item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title {
      margin-right: 10px;
      display: inline-block;
    }
    .item_input {
      width: 200px;
    }
  }
}

.powder {
  background: rgb(248, 216, 216);
}
.green {
  background: rgb(52, 229, 54);
}
.yellow {
  background: rgb(255, 247, 173);
}
.blue {
  background: rgb(158, 211, 252);
}
.red {
  background: #ffa500;
}
.magRig {
  margin-right: 10px;
}
.magLfte {
  margin-left: 10px;
}
.chong {
  display: inline-block;
  width: 13px;
  height: 86%;
  margin-left: 6px;
}
.mybox {
  margin-left: 20px;
  display: flex;
  align-items: center;
}
</style>

<style>
.publicItems .el-dialog {
  margin-top: 6vh !important;
}
</style>
